// Browser-side uploader fingerprint. This is the UNTRUSTED half of uploader
// provenance (the trusted IP + geo-IP is captured server-side from the request).
// We gather only signals that need NO user permission: user agent, platform,
// languages, timezone, screen, CPU/RAM hints, touch. No geolocation prompt.
//
// A device MAC address is intentionally NOT here: browsers cannot read it (OS +
// browser security), so no web app can capture it. We surface that fact rather
// than pretend otherwise.

// djb2 string hash -> short hex id. A stable-ish, non-cryptographic device id
// from the collected attributes (not a guarantee of uniqueness).
function hashId(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i += 1) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function deviceFingerprint() {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  const scr = typeof window !== 'undefined' && window.screen ? window.screen : {};
  let timezone = '';
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    /* noop */
  }
  const fp = {
    userAgent: nav.userAgent || '',
    platform: nav.platform || '',
    vendor: nav.vendor || '',
    languages: Array.isArray(nav.languages) ? nav.languages.slice(0, 6) : nav.language ? [nav.language] : [],
    timezone,
    screen: {
      w: scr.width || 0,
      h: scr.height || 0,
      dpr: typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1,
      depth: scr.colorDepth || 0,
    },
    cores: nav.hardwareConcurrency || null,
    deviceMemory: nav.deviceMemory || null,
    touch: typeof window !== 'undefined' && ('ontouchstart' in window || (nav.maxTouchPoints || 0) > 0),
  };
  fp.id = hashId(
    [fp.userAgent, fp.platform, fp.vendor, fp.timezone, fp.screen.w, fp.screen.h, fp.screen.dpr, fp.cores, fp.deviceMemory].join('|')
  );
  return fp;
}
